import { Injectable } from '@angular/core';
import { Project } from '../models/project.model';
 
@Injectable()
export class ProjectService {
    project: Project;
    constructor() {
    }

    set(project: any) {
        this.project = project;
     }
   
     get() {
         return this.project;
     }  
}



// WEBPACK FOOTER //
// ./src/services/project.service.ts